module.exports = {"652823100":"尉犁镇","652823110":"团结镇","652823120":"兴平镇","652823200":"塔里木乡","652823203":"墩阔坦乡","652823204":"喀尔曲尕乡","652823205":"阿克苏普乡","652823206":"古勒巴格乡","652823501":"兵团三十一团","652823502":"兵团三十三团","652823503":"兵团三十四团"}


//////////////////
// WEBPACK FOOTER
// ./src/town/652823.json
// module id = 3084
// module chunks = 0